import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "Document.svg",
  "use": "Document.svg-usage",
  "viewBox": "0 0 64 64",
  "content": "<symbol viewBox=\"0 0 64 64\" xmlns=\"http://www.w3.org/2000/svg\" id=\"Document.svg\"><path d=\"m37.0208 22.0208a1 1 0 0 1 -1-1v-10.5858a1 1 0 0 1 1.707-.7071l10.5859 10.5859a1 1 0 0 1 -.707 1.707zm13 5v26a3 3 0 0 1 -3 3h-30a3 3 0 0 1 -3-3v-42a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 0 3 3h10a3 3 0 0 1 3 3.0001z\" fill-rule=\"evenodd\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol